import { render, staticRenderFns } from "./resident_obligation_outside_canada_continued_last.vue?vue&type=template&id=e306dde0&"
import script from "./resident_obligation_outside_canada_continued_last.vue?vue&type=script&lang=js&"
export * from "./resident_obligation_outside_canada_continued_last.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports